__webpack_require__.p = "/dm-notification/referrals-hub/";